// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-carousel-tab__slide {
  display: flex;
  width: 100%;
}
.home-page-carousel-tab__slide .image {
  width: 100%;
  height: auto;
  max-height: 650px;
  object-fit: cover;
  position: relative;
}
.home-page-carousel-tab__slide--withContent .content {
  min-width: 400px;
  max-width: 600px;
  width: -moz-fit-content;
  width: fit-content;
  height: 80%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 24px;
  padding: 24px;
}
.home-page-carousel-tab__slide--withContent .content h2 {
  font-size: 2.5rem;
  font-weight: 700;
}
.home-page-carousel-tab__slide--withContent .content p {
  font-size: 1.75rem;
}
@media screen and (max-width: 700px) {
  .home-page-carousel-tab__slide--withContent {
    flex-direction: column;
  }
  .home-page-carousel-tab__slide--withContent .content {
    width: 100%;
    max-width: 100%;
    height: 100px;
    position: relative;
    gap: 4px;
    margin: 0;
    padding: 8px;
  }
  .home-page-carousel-tab__slide--withContent .content h2 {
    font-size: 1.75rem;
    margin: 0;
    text-wrap: nowrap;
  }
  .home-page-carousel-tab__slide--withContent .content p {
    font-size: 1rem;
    margin: 0;
    text-wrap: nowrap;
  }
}
.home-page-carousel-tab__controller {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  transform: translateY(-6px);
  z-index: 10;
}
.home-page-carousel-tab__controller .mock-dot {
  width: 22px;
  height: 20px;
  opacity: 0;
}
@media screen and (max-width: 468px) {
  .home-page-carousel-tab__controller .mock-dot {
    width: 14px;
    height: 12px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
